// Distinct, high-contrast colors for participants on a bill. Assigned by the
// participant's position in the bill (creator = index 0) so everyone sees the
// same person in the same color.
export const PARTICIPANT_COLORS = [
  "#a855f7", // violet
  "#34d399", // mint
  "#f472b6", // pink
  "#60a5fa", // blue
  "#fbbf24", // amber
  "#f87171", // red
  "#22d3ee", // cyan
  "#a3e635", // lime
  "#fb923c", // orange
  "#e879f9", // fuchsia
];

export const colorForIndex = (i) =>
  PARTICIPANT_COLORS[((i % PARTICIPANT_COLORS.length) + PARTICIPANT_COLORS.length) % PARTICIPANT_COLORS.length];

// hex -> rgba string with the given alpha (for subtle tints/borders)
export const withAlpha = (hex, alpha) => {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
